<template>
  <div class="join-box flex-center ">
    <reveal-animation ID="join" :options="{duration:1000,delay:0}">
      <div class="flex-center flex-column">
        <div class="title fontSize24 margin-b20 font-blod">加入我们，共建移动智能终端新生态</div>
        <div class="btn text-center font-blod color-level1 cursor"
             @click="$router.push('/home/join')">立即加入
        </div>
      </div>
    </reveal-animation>
  </div>
</template>
<script>

import RevealAnimation from "@/components/common/RevealAnimation.vue";

export default {
  components: {RevealAnimation}
}
</script>
<style scoped lang="scss">
.join-box {
  width: 100%;
  height: 200px;
  background-image: url("~@/assets/img/home/join.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  .title {
    background: linear-gradient(359.9999999898547deg, #CEC298 0%, #FFF2C6 52%, #D4C79D 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
  }

  .btn {
    width: 160px;
    height: 40px;
    line-height: 40px;
    background: linear-gradient(90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
    border-radius: 59px 59px 59px 59px;
  }
}

</style>
